<template>
  <div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-4/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
          <div class="rounded-t mb-0 px-6 py-6">
            <div class="text-center mb-3">
              <h2 class="text-blueGray-500 text-xl font-bold">
                API MANAGER
              </h2>
            </div>

            <hr class="mt-6 border-b-1 border-blueGray-300" />
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <div class="w-full lg:w-12/12 px-0" v-if="alertMessage != null && alertMessage != ''">
              <div class="text-white px-4 py-2 border-0 rounded relative mb-4 bg-red-500">
                <span class="inline-block align-middle mr-8">
                  <small>{{ alertMessage }}</small>
                </span>
                <button
                  class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-2 mr-6 outline-none focus:outline-none">
                  <span>×</span>
                </button>
              </div>
            </div>
            <Form @submit="onSubmit">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  Username
                </label>
                <Field name="username" type="username" v-model="form.username" v-slot="{ field }" rules="required">
                  <input type="text"
                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-purple-500 w-full ease-linear transition-all duration-150"
                    placeholder="Username" v-bind="field" />
                </Field>
                <ErrorMessage name="username" v-slot="{ message }">
                  <div class="text-red-500 text-xs italic">{{ message }}</div>
                </ErrorMessage>
              </div>

              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  Password
                </label>
                <Field name="password" type="password" v-model="form.password" v-slot="{ field }" rules="required">
                  <input type="password"
                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-purple-500 w-full ease-linear transition-all duration-150"
                    placeholder="Password" v-bind="field" />
                </Field>
                <ErrorMessage name="password" v-slot="{ message }">
                  <div class="text-red-500 text-xs italic">{{ message }}</div>
                </ErrorMessage>
              </div>
              <div>
                <label class="inline-flex items-center cursor-pointer">
                  <input id="customCheckLogin" type="checkbox"
                    class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150" />
                  <span class="ml-2 text-sm font-semibold text-blueGray-600">
                    Remember me
                  </span>
                </label>
              </div>

              <div class="text-center mt-6">
                <button
                  class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="submit">
                  Sign In
                </button>
              </div>
            </Form>
          </div>
        </div>
        <div class="flex flex-wrap mt-6 relative">
          <div class="w-1/2">
            <a href="javascript:void(0)" class="text-blueGray-200">
              <small>Forgot password?</small>
            </a>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';
import { Form, Field, ErrorMessage } from 'vee-validate';
import UserDataService from "@/services/UserDataService";

export default {
  setup() {
    const user = useUserStore();
    // eslint-disable-next-line no-unused-vars
    const { name, doubleCounter, Fullname } = storeToRefs(user);
    //console.log(user.Fullname)
    return {
      // you can return the whole store instance to use it in the template
      user,
    }
  },
  components: {
    Form,
    Field,
    ErrorMessage
  },
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      alertMessage: localStorage.getItem('flash')
    };
  },
  methods: {
    onSubmit() {
      UserDataService.login({ username: this.form.username, password: this.form.password })
        .then(response => {
          console.log(response.data);
          localStorage.setItem('user', JSON.stringify(response.data.data));
          document.location = '/admin/dashboard'
        })
        .catch(e => {
          console.log(e);
          this.alertMessage = e.response.data.code_message
        });
    }
  },
  created() {
    localStorage.removeItem('flash')
  }
};
</script>
